import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { useInstance } from 'intact-vue';
import { useState, watchState } from '../../hooks/useState';
import { isNullOrUndefined } from 'intact-shared';
import { isEqualArray, last } from '../utils';
export function useValue() {
  var instance = useInstance();
  // Normalize the value to multipe values, no matter it's multipe or not
  var values = useState([]);
  var showedValue = useState([]);
  instance.watch('value', function (value, oldValue) {
    var _instance$get = instance.get(),
      multiple = _instance$get.multiple;
    if (isNullOrUndefined(value)) return values.set([]);
    if (multiple) {
      values.set(value);
    } else {
      values.set([value]);
    }
  });
  watchState(values, function (values, oldValue) {
    if (isEqualArray(values, oldValue)) return;
    if (!instance.get('multiple')) {
      instance.set({
        value: values[0]
      });
    } else {
      instance.set({
        value: values
      });
    }
  });
  instance.watch('show', function (value) {
    if (value) {
      showedValue.set(last(values.value) || []);
    }
  });
  function isShowed(value, level) {
    return showedValue.value[level] === value;
  }
  function isSelected(value, level) {
    var _context;
    return _findIndexInstanceProperty(_context = values.value).call(_context, function (_value) {
      return _value[level] === value;
    }) > -1;
  }
  function onSubDropdownShow(value, level) {
    var _context2;
    var _value = _sliceInstanceProperty(_context2 = showedValue.value).call(_context2, 0, level);
    _value[level] = value;
    showedValue.set(_value);
    if (instance.get('changeOnSelect')) {
      onSelect(value, level);
    }
  }
  function onSubDropdownHide(value, level) {
    var _context3;
    if (showedValue.value[level] !== value) return;
    var _value = _sliceInstanceProperty(_context3 = showedValue.value).call(_context3, 0, level);
    showedValue.set(_value);
  }
  function toggleShowedValue(value, level, showed) {
    if (showed) {
      onSubDropdownShow(value, level);
    } else {
      onSubDropdownHide(value, level);
    }
  }
  function onSelect(value, level) {
    var _context4;
    // maybe the showedValue has the leaf value when we set it on show menu,
    // if we select by clicking, the showedValue has not the leaf value,
    // no matter which case, we set the last value by level
    var newValue = _sliceInstanceProperty(_context4 = showedValue.value).call(_context4, 0, level);
    newValue[level] = value;
    setValue(newValue);
  }
  function setValue(newValue) {
    if (instance.get('multiple')) {
      var _context5;
      var oldValue = values.value;
      // ignore the same value
      if (_findInstanceProperty(oldValue).call(oldValue, function (value) {
        return isEqualArray(value, newValue);
      })) return;
      values.set(_concatInstanceProperty(_context5 = []).call(_context5, oldValue, [newValue]));
    } else {
      values.set([newValue]);
    }
  }
  return {
    values: values,
    isShowed: isShowed,
    isSelected: isSelected,
    onSelect: onSelect,
    toggleShowedValue: toggleShowedValue,
    setValue: setValue
  };
}